import * as React from 'react';
import { resolve } from 'inversify-react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ControllerProps } from 'src/router';
import { PolicyListDataService } from './policy-list.data';
import { PolicyListView } from './policy-list.view';

@observer
export class PolicyListController extends React.Component<ControllerProps<any>, {}> {
	@observable
	dataService: PolicyListDataService;

	@resolve
	toast: ToastNotifications;

	constructor(props: Readonly<ControllerProps<any>>) {
		super(props);
	}

	private async loadData(): Promise<void> {
		this.dataService = PolicyListDataService.make();

		this.dataService.addSorting('id', 'asc', true);
		this.dataService.addFilter('isDeleted', 'eq', false);
		await this.dataService.load(query => query);
	}

	onItemDoubleClicked = (item?: PolicySummary): void => {
		this.props.history.push(`/bookings/policies/${item == null ? 'new' : item.id}`);
	}

	componentDidMount() {
		this.props.setBusy(true);
		this.loadData()
			.catch((error) => {
				this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
			})
			.then(() => {
				this.props.setBusy(false);
			});
	}

	render() {
		if (this.dataService == null || this.dataService.items == null) {
			return null;
		}

		return (
			<PolicyListView
				model={this.dataService}
				setBusy={this.props.setBusy}
				onItemDoubleClicked={this.onItemDoubleClicked}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/policies/list/policy-list.controller.tsx